import {APIClass} from 'aws-amplify';
import {DEFAULT_API_NAME} from './Auth';

/** Logs something on server. */
export const sendLog = async (
  api: APIClass | null,
  body: {
    errCode: string;
    errText: string;
  } & Record<string, unknown>,
) => {
  if (!api) {
    return;
  }

  if (process.env.NODE_ENV === 'development') {
    console.error('sendLog:', body.errCode, body);
    return;
  }

  if (process.env.NODE_ENV === 'production') {
    try {
      await api.post(DEFAULT_API_NAME, `/log-object`, {body});
    } catch (err) {
      console.error('error sending logs:', err);
    }
    return;
  }
};
